import {createSlice, current} from "@reduxjs/toolkit";
import { getUserInitialize } from "./actions.js";

const credentialState = {
    token: '',
    error: '',
    initialized: false,
    loader: false
};

const initialSlice = {
    step: 0,
    components: [],
    replayComponentsData: [],
    formInputFields: [],
    redirect_url: '',
    loader: true,
    appLoader: false,
    otp: '',
    error: '',
    image: '',
    initialized: false,
    userData: null,
    elementResponse: null,
    senderResponse: null,
    recieverResponse: null,
    surepassNumber: '',
    recieverNumber: '',
    eventType: '',
    formData: null,
    interfaceSession: null,
    file: null,
    nextEventTypeData: null,
    brandingData: null,
    eventData: null,
    interfaceBlockType: '',
    textData: '',
    event: '',
    otpSent: false,
    initialLoad: true,
    stepsArray: [0],
    traceData: [],
    brandIcon: '',
    selectItem: '',
    progressState: [],
    nextEventData: null,
    isNext: true,
    isPrevious: false,
    currentPayload: null,
    socket: null,
    inputError: '',
    startInterfaceBlockID: '',
    blockError: null,
    errorToastMessage: '',
    buttonInputHint: null,
    isHalt: false,
    isTerminate: false,
    replayComponentStep: 0,
    prev: false,
    progressLoader: true,
    aadhaarReplayCompStep: 0 , //For aadhaar okyc step
    aadhaarReplayComponentsData:[], // For aadhaar okyc data replay
    isExplicitRetrying: false

};

const hasBlock = (arr, type) => arr.some(item => item?.data?.interface_block_type === type);
const removeBlock = (arr, blockType, messageType) => {
    const index = arr.findIndex(item => item?.data?.interface_block_type === blockType && item?.data?.message?.message_type === messageType);
    if (index > -1) arr.splice(index, 1);
};

const hostedSlices = createSlice({
    name: 'hosted',
    initialState: initialSlice,
    reducers: {
        setIsTerminate:(state, action) => {
            state.isTerminate = action.payload;
            state.blockError = '';
        },

        //For OKYC Aadhaar Wizard
        setAadhaarReplayCompStep: (state, action) => {
            state.aadhaarReplayCompStep = action.payload;
        },
        setAadhaarReplayCompData: (state, action)=>{
            state.aadhaarReplayComponentsData = action.payload;
        },
        setIsHalt:(state, action) =>{
            state.isHalt = action.payload;
            state.blockError = '';
        },
        clearState: () => initialSlice,
        setStartInterfaceBlockID: (state, { payload }) => { state.startInterfaceBlockID = payload; },
        setBlockError: (state, { payload }) => { state.blockError = payload; },
        setInputError: (state, { payload }) => { state.inputError = payload; },
        setCurrentPayload: (state, { payload }) => { state.currentPayload = payload; },
        setAppLoader: (state, { payload }) => { state.appLoader = payload; },
        setBrandIcon: (state, { payload }) => { state.brandIcon = payload; },
        setBrandingData: (state, { payload }) => { state.brandingData = payload; },
        setReplayComponentStep: (state, { payload }) => { state.replayComponentStep = payload; },
        setComponentData: (state, { payload }) => {
            const existing = [...state.components];
            const incoming = payload.map(item => ({ ...item }));

            if (hasBlock(existing, 'on_start_widget_block') && hasBlock(existing, 'flash_message_widget_block')) {
                removeBlock(existing, 'on_start_widget_block', 'TRACE');
                removeBlock(existing, 'flash_message_widget_block', 'TRACE');
                removeBlock(existing, 'flash_message_widget_block', 'ELEMENT');
            }

            const merged = [...existing, ...incoming].filter((item, index, self) => {
                const isRouter = item?.data?.interface_block_type === 'router_block';
                return !isRouter
            });

            const updatedComponents =  merged.map((item, index, self) => {
                if(state.replayComponentsData?.length){
                    return (
                        {
                            ...item,
                            value: state.replayComponentsData[index]?.data?.text || state.replayComponentsData[index]?.data?.value || state.components[index]?.value || '',
                            file: state.replayComponentsData[index]?.data?.data ||  state.components[index]?.file || '',
                        }
                    )
                }
                return item
            });



            console.log(updatedComponents,merged, "Updating");

            state.event = payload?.[0]?.data?.message?.message_type;
            state.components = updatedComponents;
            state.appLoader = false;
            state.isHalt = false;
            state.isTerminate = false;
            state.step = state.blockError ? state.step : (merged.length > 1 ? merged.length-1  : state.step);
        },
        setElementData: (state, { payload }) => { state.elementResponse = payload || null; },
        setError: (state, { payload }) => { state.error = payload || ''; },
        setFieldValue: (state, { payload }) => { state.components = payload; },
        setFile: (state, { payload }) => { state.file = payload; },
        setFormInputFields: (state, { payload }) => { state.formInputFields = payload; },
        setHintData: (state, { payload }) => {
            state.eventData = payload || null;
            state.eventType = payload?.interaction_type || '';
        },
        setPrevious: (state, { payload }) => { state.isPrevious = payload; },
        setProgressState: (state, { payload }) => { state.progressState = payload; },
        setReplayComponents: (state, { payload }) => {
            state.replayComponentsData = payload?.interactions;
            state.replayComponentStep = payload?.interactions?.length-1;
            state.initialLoad = false;
        },
        setSessionData: (state, { payload }) => { state.interfaceSession = payload; },
        setSteps: (state, { payload }) => { state.step = payload; },
        setTraceData: (state, { payload }) => {

            state.traceData = state.traceData?.length ? [...state.traceData, ...payload] : payload;
        },
        setSocket: (state, { payload }) => { state.socket = payload; },
        setErrorToastMessage: (state, { payload }) => { state.errorToastMessage = payload; },
        setButtonInputHint: (state, { payload }) => { state.buttonInputHint = payload; },
        setProgressLoader: (state, { payload }) => { state.progressLoader = payload; },
        setPrev: (state, { payload }) => { state.prev = payload; },
        setIsExplicitRetrying: (state, action) => {
            state.isExplicitRetrying = action.payload;
        },
    }
});

const credentialSlice = createSlice({
    name: 'credential',
    initialState: credentialState,
    reducers: {
        setLoader: (state, action) => { state.loader = action.payload; },
        setErrorMessage: (state, action) => { state.error = action.payload; }
    },
    extraReducers: builder => builder
        .addCase(getUserInitialize.pending, (state) => {
            state.loader = true;
            state.error = '';
        })
        .addCase(getUserInitialize.fulfilled, (state, { payload }) => {
            state.initialized = true;
            state.token = payload?.authorization?.access_token;
        })
        .addCase(getUserInitialize.rejected, (state, { payload }) => {
            state.error = payload?.data?.detail;
            state.loader = false;
        })
});

export const {
    setPrev,
    setSteps,
    setAppLoader,
    setPrevious,
    setHintData,
    setSocket,
    setInputError,
    setComponentData,
    setError,
    setBrandIcon,
    setBrandingData,
    setSessionData,
    setReplayComponents,
    setFieldValue,
    setTraceData,
    setProgressState,
    setFormInputFields,
    setStartInterfaceBlockID,
    setBlockError,
    setErrorToastMessage,
    setAadhaarReplayCompStep,
    setButtonInputHint,
    setIsHalt,
    setIsTerminate,
    setReplayComponentStep,
    setProgressLoader,
    setAadhaarReplayCompData,
    setIsExplicitRetrying
} = hostedSlices.actions;

export const { setLoader, setErrorMessage } = credentialSlice.actions;

export default hostedSlices.reducer;
export const credentialReducer = credentialSlice.reducer;